import './polyfills';
import { AuroraRoot } from '@aurora/widgets-react';
import React from 'react';
import ReactDOM from 'react-dom';
import { App } from './components/App';
import moment from 'moment-timezone';
import i18n from './i18n/i18n';
import { AppContext, reduxStore } from './AppContext';
import { connect, Provider } from 'react-redux';
import { actions as applicationActions } from 'wpt-duck-application';

moment.locale(i18n.language);

const applicationConfig = {
  backend: 'backend_seaice',
  port: 64297,
};

// provide the redux state to the app context
const AppWithContext = (props) => (
  <AuroraRoot>
    <AppContext.Provider value={props}>
      <App />
    </AppContext.Provider>
  </AuroraRoot>
);

const mapStateToProps = (state) => ({
  state,
});
const mapDispatchToProps = (dispatch) => ({
  dispatch,
});

const AppWithContextContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(AppWithContext);

//Provide the redux store to redux's connect method.
ReactDOM.render(
  <Provider store={reduxStore}>
    <AppWithContextContainer />
  </Provider>,
  document.getElementById('root')
);

reduxStore.dispatch(applicationActions.init(applicationConfig));
